class Cn
{
    constructor()
    {
        this.general = {

        }

        this.organization = {

        }

        this.mainmenu = {
            home: "首页",

            intro: "那空沙旺皇家大学概况",
            organization: "学院及单位",
            education: "教育信息",
            service: "Services",

            forProspective: "Prospective",
            forStudent: "Student",
            forAlumni: "Alumni",
            forParent: "Parent",
            forPerson: "Person",
            forStaff: "Teacher & Staff",
        }
    }
}

export default Cn
